module.exports = __webpack_public_path__ + "static/img/about_map@2x.c445a3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_map@2x.png
// module id = 275
// module chunks = 1